import React from 'react';
import './App.css';
import Home from './components/Home';
import About from './components/About';


function App() {
  return (
    <div className="App">
      
      
      <Home />
    
    </div>
  );
}

export default App;
